import posthog from "posthog-js";

import packageJson from "../package.json";

if (!process.env.NEXT_PUBLIC_POSTHOG_KEY)
	throw new Error("NEXT_PUBLIC_POSTHOG_KEY is undefined");

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
	api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
	person_profiles: "always",
	capture_pageview: "history_change",
	capture_exceptions: true,
	loaded: posthog => {
		posthog.debug(process.env.NEXT_PUBLIC_VERCEL_ENV !== "production");
	},
});

console.log(`You are running Vita v${packageJson.version}`);

console.log(`
          learnlearnle      arnlearnlearn     
       learnlearnlearnl   earnlearnlearnlea   
      rnlearnlearnlear  nlearnlearnlearnlearn 
     learnlea      r   nlearnle       arnlearn
     learnle          arnlearn         learnle    Passionate about education? Come work at Vita!
     arnlear         nlearnle          arnlear           Email rich@vitalearning.ca
     nlearnle      arnlearnlear      nlearnlea
      rnlearnlearnlearnlearnlearnlearnlearnle 
       arnlearnlearnlearn learnlearnlearnle   
          arnlearnlear      nlearnlearnle     
		`);
